import { useSelector } from 'react-redux';

import Grid from '@anwb/poncho/components/grid';
import List from '@anwb/poncho/components/list';
import Typography from '@anwb/poncho/components/typography';

import {
	defaultUpgradeSelector,
	isNewCarSelector,
	leaseCarUpgradesSelector,
} from '../../../../../../../store/selectors';
import { StandardEquipment, Upgrade } from '../../../../../../../types';
import { getComparingUpgrade } from '../../utils';
import { getUniqueStandardEquipments } from '../../utils/getUniqueStandardEquipments';
import { setGroupedItems } from '../utils/setGroupedItems';
import { setSortedGroups } from '../utils/setSortedGroups';

type Props = {
	selectedVehicle: Upgrade | undefined;
};

export const SelectedVehicleOptions = ({ selectedVehicle }: Props) => {
	const upgrades: Upgrade[] = useSelector(leaseCarUpgradesSelector);
	const basicUpgrade: Upgrade = useSelector(defaultUpgradeSelector);
	const isNewCar = useSelector(isNewCarSelector);

	if (!selectedVehicle) {
		return null;
	}

	const comparingTo: Upgrade = getComparingUpgrade(upgrades, selectedVehicle, basicUpgrade);

	const isStandardEquipmentListShown =
		selectedVehicle.vehicleData.standardEquipment === comparingTo.vehicleData.standardEquipment;

	const standardEquipment: StandardEquipment[] = selectedVehicle.monthPrice
		? getUniqueStandardEquipments(
				comparingTo.vehicleData.standardEquipment,
				selectedVehicle.vehicleData.standardEquipment
			)
		: basicUpgrade.vehicleData.standardEquipment;

	const groupedItems = setGroupedItems({ standardEquipment });
	const sortedGroups = setSortedGroups({ groupedItems });

	return (
		<Grid.Item>
			<Typography variant="component-subtitle">
				{!isStandardEquipmentListShown
					? `Extra uitrusting t.o.v. ${basicUpgrade.description}`
					: isNewCar
						? 'Standaarduitrusting'
						: 'Uitrusting'}
			</Typography>

			<List>
				{sortedGroups.map(({ group, items }) => (
					<List.Item title={group} key={group}>
						<List>
							{items.map((item) => (
								<List.Item variant="checked" key={item}>
									{item}
								</List.Item>
							))}
						</List>
					</List.Item>
				))}
			</List>
		</Grid.Item>
	);
};
